import React from 'react';

const TitleOneCard = ({ title, value }) => {
  return (
    <div 
      className="w-full mx-auto my-4 bg-[#34495e] border-2 border-[#2ecc71] rounded-[10px] flex items-center justify-center p-2 cursor-pointer"
      style={{ minHeight: '45px', maxHeight:'80px' }} // Slightly taller than 50px to fit text & animation
    >
      <div className="flex items-center text-center flex-col text-white mr-1">
        <span className="p-8 font-medium">{title}</span>
        {value && <span className="text-sm font-light">{value}</span>}
      </div>
    </div>
  );
};

export default TitleOneCard;